"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.layoutTextBox = void 0;
var derive_font_metrics_1 = require("./derive-font-metrics");
var legacy_1_1 = require("./legacy-1");
var legacy_2_1 = require("./legacy-2");
var units_1 = require("./units");
var layoutTextForRenderMethod = {
    LEGACY_1: legacy_1_1.layoutText,
    LEGACY_2: legacy_2_1.layoutText,
};
var MAGIC_MEASURE_DELTA = {
    LEGACY_1: 1,
    LEGACY_2: 0,
};
var layoutTextBox = function (_a) {
    var renderMethod = _a.renderMethod, text = _a.text, width = _a.width, height = _a.height, maxFontSize = _a.maxFontSize, lineSpacing = _a.lineSpacing, horizontalAlignment = _a.horizontalAlignment, verticalAlignment = _a.verticalAlignment, fontMetrics = _a.fontMetrics, measureTextWidth = _a.measureTextWidth;
    var layoutText = layoutTextForRenderMethod[renderMethod];
    var layout = layoutText({
        fontData: { fontMetrics: fontMetrics },
        width: width,
        height: height,
        text: text,
        horizontalAlignment: horizontalAlignment,
        verticalAlignment: verticalAlignment,
        maxFontSize: maxFontSize,
        lineSpacing: lineSpacing,
        measureTextWidth: function (_a) {
            var text = _a.text, fontSize = _a.fontSize;
            return (measureTextWidth({ text: text, fontSize: (0, units_1.convertPointsToMM)(fontSize) }) +
                MAGIC_MEASURE_DELTA[renderMethod]);
        },
        measureTextHeight: function (_a) {
            var fontSize = _a.fontSize, intrinsic = _a.intrinsic;
            if (intrinsic) {
                var lineHeight = (0, derive_font_metrics_1.deriveLineHeight)({
                    fontMetrics: fontMetrics,
                    fontSize: (0, units_1.convertPointsToMM)(fontSize),
                });
                return lineHeight + MAGIC_MEASURE_DELTA[renderMethod];
            }
            return (0, units_1.convertPointsToMM)(fontSize * (lineSpacing / maxFontSize));
        },
    });
    return {
        fontSize: (0, units_1.convertPointsToMM)(layout.fontSize),
        maxFontSize: (0, units_1.convertPointsToMM)(layout.maxFontSize),
        lineHeight: layout.lineHeight,
        lineOffsetY: layout.lineOffsetY,
        fragments: layout.fragments,
    };
};
exports.layoutTextBox = layoutTextBox;
